import { media, spacing } from '@gyym/ui'
import styled, { css } from 'styled-components'

interface HeadingContainerProps {
  pcOnly?: boolean
  centered?: boolean
}

export const HeadingContainer = styled.div<HeadingContainerProps>`
  width: 100%;
  margin: 0 auto;
  align-items: center;
  display: ${({ pcOnly }) => (pcOnly ? 'none' : 'flex')};
  flex-wrap: wrap;
  gap: 0 ${spacing(4)};

  ${media.pc} {
    display: flex;
  }

  ${({ centered }) =>
    centered &&
    css`
      justify-content: center;
    `}
`
